import { render, staticRenderFns } from "./BienResults.vue?vue&type=template&id=2501865b&scoped=true"
import script from "./BienResults.vue?vue&type=script&lang=js"
export * from "./BienResults.vue?vue&type=script&lang=js"
import style0 from "./BienResults.vue?vue&type=style&index=0&id=2501865b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2501865b",
  null
  
)

export default component.exports